import { jsx } from '@emotion/react';
import { AccountsMenuLinks, moveZapsLink } from '../../constants';
import { useUniversalNavContext, useQuerySession, useQueryAccountsList, } from '../../hooks';
import AccountsMenu from './AccountsMenu';
const AccountsMenuContainer = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data: accountsData } = useQueryAccountsList();
    const { data: sessionData } = useQuerySession();
    const accounts = (accountsData || []).map((account) => ({
        id: account.id,
        name: account.normalizedName,
        imageUrl: account.normalizedImageUrl,
        accountSwitcherUrl: getFullyQualifiedURL(`/switch-account?account=${account.id}&next=${window.location.href}`),
        planName: account.planName,
        hasTeams: account.hasTeams,
        parentAccount: account.parentAccount,
        parentAccountRelationship: account.parentAccountRelationship,
    }));
    const menuLinks = [
        ...AccountsMenuLinks.map((link) => (Object.assign(Object.assign({}, link), { href: getFullyQualifiedURL(link.href) || null }))),
    ];
    if (accounts.length > 1) {
        menuLinks.unshift(moveZapsLink);
    }
    const email = (sessionData === null || sessionData === void 0 ? void 0 : sessionData.email) || '';
    return (jsx(AccountsMenu, Object.assign({ accounts: accounts, email: email, menuLinks: menuLinks }, props)));
};
export default AccountsMenuContainer;
//# sourceMappingURL=AccountsMenuContainer.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
